import states from 'states-us';

export interface SelectOption {
  value: string | number;
  label: string;
}

export const StateOptions: SelectOption[] = states.map((state) => ({
  value: state.abbreviation,
  label: state.name,
}));
